import {
  useRoute,
  useRouter,
  defineNuxtPlugin,
  useRuntimeConfig,
  useCurrentLanguage
} from "#imports";
export default defineNuxtPlugin({
  async setup() {
    const config = useRuntimeConfig().public.languageNegotiation;
    const availableLanguages = config.availableLanguages;
    const route = useRoute();
    const router = useRouter();
    function translateRouteRecord(v) {
      return availableLanguages.map((language) => {
        const name = v.name?.toString() || "";
        const mapping = v.meta.languageMapping || {};
        let path = mapping[language] || `/${language}${v.path}`;
        if (!mapping[language] && config.defaultLanguageNoPrefix && language === config.defaultLanguage) {
          path = v.path;
        }
        const translated = {
          ...v,
          name: name + "___" + language,
          path: path.replace(/\/$/, "")
        };
        translated.children = translated.children.map((child) => {
          const childName = child.name?.toString() || "";
          return {
            ...child,
            name: childName + "___" + language
          };
        });
        return translated;
      });
    }
    router.getRoutes().forEach((v) => {
      if (typeof v.name === "string") {
        router.removeRoute(v.name);
        translateRouteRecord(v).forEach(
          (translatedRecord) => router.addRoute(translatedRecord)
        );
      }
    });
    const currentLanguage = useCurrentLanguage();
    function translateLocation(v) {
      if (typeof v === "object") {
        const translated = { ...v };
        if ("name" in translated) {
          const name = translated.name?.toString() || "";
          if (name && !name.includes("___")) {
            translated.name = name + "___" + currentLanguage.value;
          }
        }
        return translated;
      }
      return v;
    }
    const originalResolve = router.resolve;
    router.resolve = (to, currentLocation) => {
      return originalResolve(translateLocation(to), currentLocation);
    };
    const originalPush = router.push;
    router.push = function(v) {
      return originalPush(translateLocation(v));
    };
    const originalReplace = router.replace;
    router.replace = function(v) {
      return originalReplace(translateLocation(v));
    };
    await router.replace({
      path: route.path,
      query: {
        ...route.query
      },
      force: true
    });
  }
});
